import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '_lib/theme';

type Props = {
  children: React.ReactNode;
  color?: string;
};

const useStyles = createUseStyles((theme: Theme) => ({
  container: (props: Props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    width: 'fit-content',
    padding: '4px 12px 3px',

    fontSize: 10,
    fontWeight: 700,
    fontFamily: theme.typography.fontFamily,
    textTransform: 'uppercase',
    color: '#fff',

    borderRadius: 100,
    background:
      props.color || 'linear-gradient(90deg, #FF6243 0%, #FF0072 100%)',
  }),
}));

const Pill = (props: Props) => {
  const classes = useStyles(props);
  const { children } = props;

  return (
    <div className={classes.container}>
      <span>{children}</span>
    </div>
  );
};

export default Pill;
